define([
	'internal_util/Util',
	'@ecsec/base-libs/dist/webcrypto'
], function (
	Util,
	webcrypto
) {
	'use strict';

	/**
	 * AbstractKeyBindingType class
	 * 
	 * @param origin key-origin eg FIDO/Browser
	 * @returns {AbstractKeyBinding}
	 */
	return function (origin, type, salt) {
		
		var _type;
		var _origin = origin;
		var _salt = salt;
		
		var _secret = null;
		var _usePVR = false;
	
		if (Util.isValidString(type)) {
			_type = type;
		} else {
			throw new Error('invalid binding type: ' + type);
		}

		// public methods
		
		this.type = function () {
			return _type;
		};

		this.origin = function() {
			return _origin;
		};
		
		this.salt = function() {
			return _salt;
		};
		
		this.setPVR = function(salt, secret, usePVR) {
			_salt = salt;
			_secret = secret;
			_usePVR = usePVR;
		};
		
		this.getPVR = function() {
			if ((_secret !== null || _secret !== "") && _usePVR) {
				return webcrypto.hashHex(_salt + _secret, webcrypto.hashAlgo.sha256);
			}
			return "";
		};
		
		this.toObject = function () {
			return {
				type : this.type(),
				origin : _origin,
				salt: _salt
			};
		};

	};
});



//////////////////
// WEBPACK FOOTER
// ./src/main/web/js/app/model/bindings/AbstractKeyBindingType.js
// module id = 106
// module chunks = 3